import AddIcon from '@mui/icons-material/Add';
import DeleteButton from '../components/DeleteButton';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Grid, IconButton, InputAdornment, TextField, Toolbar } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router';

import { ContextStore } from '../store/contextStore';
import { debounce } from '../utils';

export const RegionsListToolbar = (props) => {
    const createBt = React.useRef(null);
    const deleteBt = React.useRef(null);
    const history = useHistory();
    const searchQueryRef = React.useRef(null);
    const { hasPerm } = React.useContext(ContextStore);
    // const history = useHistory();
    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const onCreateNewRegionBtClick = (ev) => {
        history.push('/explore/regions/create');
    };

    const onDeleteRegionBtClick = (ev) => {
        props.onDeleteRegion && props.onDeleteRegion(props.selectedIds);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);

    return (
        <Toolbar disableGutters={true} sx={{ minHeight: 0 }}>
            <Grid container direction="row">
                <Grid item xs={12} sm={4} container spacing={2} alignItems={'center'}>
                    <Grid item xs={9} sm={12}>
                        <TextField
                            variant="filled"
                            label="Search"
                            size="small"
                            onChange={debouncedSearchQueryChangeHandler}
                            inputRef={searchQueryRef}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    {props.isSmallScreen && hasPerm('region', 'write') && (
                        <Grid item xs={3} container justifyContent={'flex-end'}>
                            <Button ref={createBt} onClick={onCreateNewRegionBtClick} variant="contained" color="primary">
                                <AddIcon />
                            </Button>
                        </Grid>
                    )}
                </Grid>
                <Grid item xs={4} sm={8} container justifyContent="flex-end" alignItems="center">
                    {props.selectedIds && props.selectedIds.length > 0 ? (
                        <Box mr={2}>
                            <DeleteButton ref={deleteBt} perm="region.delete" size="small" onClick={onDeleteRegionBtClick}>
                                Delete region{props.selectedIds.length > 1 ? 's' : ''}
                            </DeleteButton>
                        </Box>
                    ) : null}
                    {hasPerm('region', 'write') && props.newRowOrder && Object.keys(props.newRowOrder).length ? (
                        <>
                            <Box mr={2}>
                                <Button color="secondary" variant="contained" size="small" onClick={(ev) => props.onSaveNewOrder(true)}>
                                    X&nbsp;&nbsp;Cancel
                                </Button>
                            </Box>
                            <Box mr={2}>
                                <Button color="primary" variant="contained" size="small" onClick={() => props.onSaveNewOrder()}>
                                    <SaveIcon />
                                    &nbsp;Save new order
                                </Button>
                            </Box>
                        </>
                    ) : null}
                    {!hasPerm('region', 'write') || props.isSmallScreen || props.newRowOrder || props.selectedIds?.length > 0 ? null : (
                        <Box direction="row-reverse">
                            <Button ref={createBt} color="primary" variant="contained" size={props.isSmallScreen ? 'normal' : 'small'} onClick={onCreateNewRegionBtClick}>
                                <AddIcon />
                                &nbsp;{!props.isSmallScreen ? 'New region' : null}
                            </Button>
                        </Box>
                    )}
                </Grid>
            </Grid>
            {/* {props.isSmallScreen ? (
                <Box position="fixed" right={theme.spacing(3)} bottom={theme.spacing(3)} zIndex={99000}>
                    <Fab color="primary" onClick={onCreateNewRegionBtClick}>
                        <AddIcon />
                    </Fab>
                </Box>
            ) : null} */}
        </Toolbar>
    );
};

export default RegionsListToolbar;
